module.exports = __webpack_public_path__ + "public/images/artist.df610b1ab2f9f18430e0a9ba2976c396.webp";